import type { ContentWithTitleProps } from './ContentWithTitle.types';

const ContentWithTitle: React.FC<ContentWithTitleProps> = ({
  title,
  content,
  variant = 'primary',
}) => {
  const TitleElement = variant === 'primary' ? 'h2' : 'h3';
  const headingSize = variant === 'primary' ? 'h2' : 'h4';

  return (
    <div className={`page-intro page-intro--${variant}`}>
      <div className="page-intro__container container">
        {title && (
          <TitleElement
            className={`page-intro__heading ${headingSize}`}
            dangerouslySetInnerHTML={{ __html: title }}
          />
        )}
        {content && (
          <div
            className="page-intro__summary lead"
            dangerouslySetInnerHTML={{ __html: content }}
          />
        )}
      </div>
    </div>
  );
};

export default ContentWithTitle;
